import React from "react";
import { ReactComponent as WarningIcon } from "../../../img/warning_triangle.svg";
import { Spacer } from "../../../components/general/Spacer/Spacer";

export interface BackToSwapButtonProps {
  message: string;
}

export const WarningSection: React.FC<BackToSwapButtonProps> = props => {
  return (
    <>
      <div
        className="inline-error d-flex align-items-start warning-information"
        style={{ fontSize: "14px", padding: "10px", lineHeight: "20px" }}
      >
        <div style={{ width: "20px", height: "20px" }}>
          <WarningIcon width={20} height={20} strokeWidth={1.5} />
        </div>
        <Spacer width="10px" />
        {props.message}
      </div>
      <div className="sp24"></div>
    </>
  );
};
